<template>
  <transition name="slide" :duration="0">
    <div class="component overlay" v-on:click="$emit('update:active', false)">
      <div class="modal">
        <div class="container">
          <div class="row">
            <div class="col-xl-10 offset-xl-1">
              <div class="card">
                <a
                  href="#"
                  v-on:click.prevent="$emit('update:active', false)"
                  class="navigation-icon close"
                ></a>
                <p>I want to learn about</p>
                <ul>
                  <li v-for="item in items">
                    <a v-bind:href="item.href">{{ item.title }}</a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="backdrop"></div>
    </div>
  </transition>
</template>

<script>
export default {
  name: "navigation-card",
  props: ["items", "active"],
};
</script>

<style lang="scss" scoped>
@import "../../css/abstracts/path";
@import "../../css/abstracts/colors";
@import "../../css/base/typography";
@import "../../css/components/navigation";

.slide-enter {
  li {
    opacity: 0;
    transform: translateX(80px);
  }
}

.slide-enter-active {
  li {
    transition: opacity 0.5s ease-out, transform 0.5s ease-out;
  }
}

.overlay {
  z-index: 102;
  position: fixed;
  top: 0;
  left: 0;

  opacity: 0;
  animation: fade-in 1s;
  animation-timing-function: ease;
  animation-delay: 0.25s;
  animation-fill-mode: forwards;

  .modal {
    overflow-x: hidden;
    overflow-y: auto;

    z-index: 110;
    position: fixed;

    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
  }

  .card {
    background-color: $cc-resmed-white;
    box-shadow: 0 2rem 3rem 0 rgba(0, 0, 0, 0.125);
    border-radius: 6px;
    padding: 4rem;

    position: absolute;
    top: 3rem;
    left: 50%;
    transform: translateX(-50%);
    min-width: 330px;

    @media (min-width: 576px) {
      top: 240px;
      // left: auto;
      // right: 150px;
    }

    ul {
      overflow: hidden;

      li {
        @extend %default-list-style;
        background-image: none;

        // stagger
        @for $i from 1 through 10 {
          &:nth-child(#{$i}) {
            transition-delay: #{$i/10}s;
          }
        }

        a {
          padding: 0.825rem 2rem 0.825rem 0;

          background-position: right center;
          background-size: 0.75rem 0.75rem;
          background-repeat: no-repeat;
          background-image: url(#{$assets}/images/icon-right-arrow-black.svg);

          &:hover,
          &:focus {
            background-image: url(#{$assets}/images/icon-right-arrow-red.svg);
            color: $cc-resmed-action-red;
            opacity: 1;
          }

          &::first-letter {
            text-transform: uppercase;
          }
        }
      }
    }

    p {
      position: relative;

      &:before {
        content: "";
        position: absolute;
        top: -1.25rem;
        left: 0;
        width: 1.25rem;
        height: 3px;
        background-color: $cc-resmed-dark-grey;
      }
    }
  }

  .backdrop {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;

    z-index: 105;
    background-color: rgba($cc-resmed-deep-blue, 0.75);
  }
}

.navigation-icon {
  position: absolute;
  top: -1.125rem;
  right: -1.125rem;
}
</style>